module.exports = __webpack_public_path__ + "static/media/error.53077323.svg";